<template>
  <div class="swiper-container">
    <div class="swiper-wrapper">
      <div v-for="(bundle, i) in computedBundles" class="swiper-slide plan-slide" :key="i">
        <div class="plan-slide-price">
          <div
              style="font-size: 14px; background: #d12984; padding: 1px 22px; color: white;border-radius: 30px; width: fit-content;">
            {{ getBundlePrice(bundle) >= 8 ? '5G' : '4G LTE' }}
          </div>
          <span>KD</span>{{ getBundlePrice(bundle) }}
        </div>
        <hr>
        <div>
          <ul>
            <li v-for="(bundleContents, bi) in Object.values(bundle).filter(x => x && x.value)"
                v-show="bundleContents.value !== '0.0'" :key="bi">
              <div class="columns is-mobile">
                <div class="column is-2 is-paddingless">
                  <img v-if="bundleContents.type.toLowerCase() === 'data'" src="../assets/wifi.png"
                       alt="plan benefit">
                  <img v-else-if="bundleContents.type.toLowerCase().includes('international')"
                       src="../assets/int-calls.png" alt="plan benefit">
                  <img v-else-if="bundleContents.type.toLowerCase().includes('minutes')"
                       src="../assets/calls.png" alt="plan benefit">
                  <img v-else-if="bundleContents.type.toLowerCase().includes('whatsapp')"
                       src="../assets/wa.png" alt="plan benefit">
                  <img v-else-if="bundleContents.type.toLowerCase().includes('social')"
                       src="../assets/fb.png" alt="plan benefit">
                  <img v-else-if="bundleContents.type.toLowerCase().includes('youtube')"
                       src="../assets/yt.png" alt="plan benefit">
                </div>
                <div class="column align-left">
                  {{ $tif(bundleContents.titleEn, bundleContents.titleAr) }}
                  <br/>
                  <small class="has-text-black"
                         v-if="bundleContents.type.toLowerCase().includes('social')">
                    (Facebook, Snapchat, Twitter, Instagram)
                  </small>

                </div>
                <div class="column is-3 align-right has-text-weight-bold">
                  {{
                    bundleContents.isUnlimited ? $t('Unlimited') : bundleContents.value.replace('.0',
                        '') + ' ' + $tif(bundleContents.unitEn, bundleContents.unitAr)
                  }}
                </div>
              </div>
            </li>
            <li>
              <span v-if="getBundlePrice(bundle) >= 8" class="p-tag">
                {{ $t('ExtraOfferBenefit') }}
              </span>
              <span>
                &nbsp;
              </span>
            </li>
          </ul>
          <b-button @click="pickPlanBundle(bundle)" style="margin-top: 20px" class="pink-btn-solid">
            {{ $t('BuyPlan') }}
          </b-button>

        </div>
      </div>
    </div>
    <br/><br/>
    <br/><br/>
  </div>
</template>
<script>
import Swiper from 'swiper/js/swiper.esm.bundle'
import BButton from "buefy/src/components/button/Button"

export default {
  name: "BundleSelector",
  components: { BButton },
  data: () => {
    return {
      bundles: [
        {
          "DATA": "200.0",
          "ONNETMINUTES": "0.0",
          "LOCALMINUTES": "9000.0",
          "INTERNATIONALMINUTES": "0.0",
          "WHATSAPP": "0.0",
          "SOCIALMEDIA": "0.0",
          "YOUTUBE": "0.0"
        },
        {
          "DATA": "50.0",
          "ONNETMINUTES": "0.0",
          "LOCALMINUTES": "500.0",
          "INTERNATIONALMINUTES": "0.0",
          "WHATSAPP": "0.0",
          "SOCIALMEDIA": "0.0",
          "YOUTUBE": "0.0"
        },
        {
          "DATA": "25.0",
          "ONNETMINUTES": "0.0",
          "LOCALMINUTES": "250.0",
          "INTERNATIONALMINUTES": "0.0",
          "WHATSAPP": "0.0",
          "SOCIALMEDIA": "0.0",
          "YOUTUBE": "0.0"
        },
        {
          "DATA": "25.0",
          "ONNETMINUTES": "0.0",
          "LOCALMINUTES": "100.0",
          "INTERNATIONALMINUTES": "0.0",
          "WHATSAPP": "0.0",
          "SOCIALMEDIA": "0.0",
          "YOUTUBE": "0.0"
        },
        {
          "DATA": "10.0",
          "ONNETMINUTES": "0.0",
          "LOCALMINUTES": "250.0",
          "INTERNATIONALMINUTES": "0.0",
          "WHATSAPP": "0.0",
          "SOCIALMEDIA": "0.0",
          "YOUTUBE": "0.0"
        },
        {
          "DATA": "10.0",
          "ONNETMINUTES": "0.0",
          "LOCALMINUTES": "50.0",
          "INTERNATIONALMINUTES": "0.0",
          "WHATSAPP": "0.0",
          "SOCIALMEDIA": "0.0",
          "YOUTUBE": "0.0"
        }
      ]
    }
  },
  computed: {
    computedBundles() {
      let vm = this

      if (this.$store.state.userInfo.tenureRestricted) {
        return this.$store.state.userInfo.tenureRestrictedPlans.map(plan => {
          return {
            data: plan.benefits.find(x => x.type === 'DATA'),
            onNetMinutes: plan.benefits.find(x => x.type === 'ONNETMINUTES'),
            localMinutes: plan.benefits.find(x => x.type === 'LOCALMINUTES'),
            info: {
              code: plan.code,
              price: plan.price
            }
          }
        })
      } else {
        let buns = this.bundles.map(bundle => {

          const f = {
            data: vm.$store.getters.getSettings().DATA.find(x => x.value === bundle.DATA),
            onNetMinutes: vm.$store.getters.getSettings().ONNETMINUTES.find(x => x.value === bundle.ONNETMINUTES),
            localMinutes: vm.$store.getters.getSettings().LOCALMINUTES.find(x => x.value === bundle.LOCALMINUTES),
            internationalMinutes: vm.$store.getters.getSettings().INTERNATIONALMINUTES.find(x => x.value === bundle.INTERNATIONALMINUTES),
            whatsapp: vm.$store.getters.getSettings().WHATSAPP.find(x => x.value === bundle.WHATSAPP),
            socialMedia: vm.$store.getters.getSettings().SOCIALMEDIA.find(x => x.value === bundle.SOCIALMEDIA),
            youTube: vm.$store.getters.getSettings().YOUTUBE.find(x => x.value === bundle.YOUTUBE)
          }

          if (!f.data || !f.onNetMinutes || !f.localMinutes || !f.internationalMinutes || !f.whatsapp || !f.socialMedia || !f.youTube) return null
          else return f

        })
        return buns.filter(x => x)
      }


    }
  },
  methods: {
    getBundlePrice(bundle) {
      //console.log(bundle)
      if (bundle.info && bundle.info.price) return bundle.info.price
      return Object.values(bundle).map(x => parseFloat(x.price)).reduce((p, c) => p + c)
    },
    pickPlanBundle(bundle) {
      this.$emit('pickedplan', {
        plan: {
          valueGBs: bundle.data,
          valueMinutesOnNet: bundle.onNetMinutes,
          valueMinutesOffNet: bundle.localMinutes,
          valueInternationalMinutes: bundle.internationalMinutes,
          valueSocialMedia: bundle.socialMedia,
          valueWhatsApp: bundle.whatsapp,
          valueYouTube: bundle.youTube,
        },
        total: this.getBundlePrice(bundle),
        code: bundle && bundle.info ? bundle.info.code : null,
        goToNextStep: true,
        planType: 'Bundle'
      })
    }
  },
  mounted() {
    new Swiper('.swiper-container', {
      spaceBetween: 10,
      slidesPerView: 'auto',
      freeMode: true,
    })
  },
}
</script>

<style scoped>
.plan-slide {
  color: black;
  background: white;
  width: 80%;
  border-radius: 5px;
  max-width: 450px;
}

.plan-slide ul {
  padding: 10px 20px 0;
  font-size: 1.1em;
}

.plan-slide li:not(:last-child) {
  margin-bottom: 15px;
  border-bottom: 1px solid #d6d6d6;

}

.plan-slide li {
  padding-bottom: 15px;
  border-radius: 0;
}

.plan-slide-price {
  padding: 10px 10px 0;
  color: #48146a;
  font-weight: bold;
  font-size: 2.3em;
}

.plan-slide-price span {
  font-weight: lighter;
  font-size: 0.6em;
  vertical-align: top;
  position: relative;
  top: 4px;
  padding-right: 5px;
}

.plan-slide hr {
  background-color: #6943d0;
  border: none;
  display: block;
  height: 1px;
  margin: 0 auto 10px;
  padding: 0 10px;
  width: 85%;
}

.plan-slide img {
  position: relative;
  top: 44%;
  transform: translateY(-50%);
  width: 40px;
}

.pink-btn-solid {
  width: 60% !important;
  color: white !important;
  font-weight: bold !important;
  background-color: #D12B8A !important;
  border-color: #D12B8A !important;
  height: 40px !important;
  margin-bottom: 20px;
}

.p-tag {
  padding: 2px 10px;
  background: #e8dafc;
  color: #48146a;
  border-radius: 10px;
  font-weight: bold;
}

</style>
